import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import propOr from 'ramda/src/propOr';
import keys from 'ramda/src/keys';
import { login } from './login';
import * as passwordRecovery from './passwordRecovery'; // ============================ utils ============================

var isPrimitive = function isPrimitive(val) {
  return Object(val) !== val;
};

var getPropertyName = function getPropertyName(prefix, key) {
  return prefix ? "".concat(prefix).concat(key.charAt(0).toUpperCase()).concat(key.slice(1)) : key;
};

var flatMap = function flatMap(map, prefix) {
  return keys(map).reduce(function (acc, value) {
    if (isPrimitive(map[value])) {
      acc[getPropertyName(prefix, value)] = map[value];
      return acc;
    }

    return _objectSpread(_objectSpread({}, acc), flatMap(map[value], getPropertyName(prefix, value)));
  }, {});
}; // ============================ config ============================


var TEST_ATTRIBUTE = 'data-test';
var ERROR_POSTFIX = '-error';
var MOBILE_POSTFIX = '-mobile';
var map = {
  accessRecovery: passwordRecovery.accessRecovery,
  login: login,
  requestRecoveryCode: passwordRecovery.requestRecoveryCode
};
var ids = keys(map).reduce(function (acc, value) {
  acc[value] = flatMap(map[value]);
  return acc;
}, {}); // ============================ export ============================

var formatValue = function formatValue(val) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      error = _ref.error,
      mobile = _ref.mobile;

  var newValue = val;

  if (error) {
    newValue += ERROR_POSTFIX;
  }

  if (mobile) {
    newValue += MOBILE_POSTFIX;
  }

  return newValue;
};

export var getTestIdGetter = function getTestIdGetter(dictKey) {
  var dictionary = propOr({}, dictKey, ids);
  return function (key, options) {
    if (typeof key === 'undefined') {
      return dictionary;
    }

    var value = dictionary[key];

    if (!value) {
      return {};
    }

    return _defineProperty({}, TEST_ATTRIBUTE, formatValue(value, options));
  };
};
export var dictKeys = {
  ACCESS_RECOVERY: 'accessRecovery',
  LOGIN: 'login',
  REQUEST_RECOVERY_CODE: 'requestRecoveryCode'
};